export const LISTS_USER_UPDATE = "lists_user_update"
export const LISTS_PROJECT_UPDATE = "lists_project_update"
export const LISTS_USER_FROM_IMPORT_UPDATE = "lists_user_from_import_update"
export const LISTS_COUNTRY_UPDATE = "lists_country_update"
export const LISTS_CUSTOMER_UPDATE = "lists_customer_update"
export const UPDATE_ANSWERS = "update_answers"
export const LISTS_EMAIL_HOTALERT_UPDATE = "lists_email_hotalert_update"
export const LISTS_EMAIL_QUALITY_DATA_UPDATE = "lists_email_quality_data_update"
export const LISTS_EMAIL_HOTALERT_CHECK_UPDATE = "lists_email_hotalert_check_update"
export const LISTS_CALL_IN_TYPE_UPDATE = "lists_call_in_type_update"
export const LISTS_CALL_IN_TYPE_SUB_1_UPDATE = "lists_call_in_type_sub_1_update"
export const LISTS_CALL_IN_TYPE_SUB_2_UPDATE = "lists_call_in_type_sub_2_update"
export const LISTS_CUSTOMER_SURVEY_UPDATE = "lists_customer_survey_update"
export const CREDIT_UPDATE = "credit_update"
export const LISTS_THEME_SMS = "lists_theme_sms"
